/** The style that keeps a picture's focus point in view, or none when the picture has no focus point. */
export function pictureFocusStyle(picture) {
    let style;
    if (picture.focus !== undefined) {
        style = { objectPosition: `${picture.focus.x}% ${picture.focus.y}%` };
    }
    return style;
}
//# sourceMappingURL=sitePicture.js.map